 <template>
  <div class="modal-address">

    <div class="row">
      <div class="col-8">
        <h6 class="text-left">Confirm your shipping details</h6>
      </div>
      <div class="col-4">
        <button class="plain float-right" v-on:click="toggleEditing"><em>Edit</em></button>
      </div>
    </div>

    <div class="row form" v-bind:class="{ 'is-editing' : isEditing }" v-if="inputVal" >

      <div class="col-12">
        <div class="row form-block">

          <div v-if="showName" class="form-group col col-md-6">
            <input
              type="text"
              class="form-control"
              v-validate="'required'"
              v-model="value.firstName"
              required
              :disabled="!isEditing || noNameChange"
              placeholder="First name" />
          </div>
          <div v-if="showName" class="form-group col col-md-6">
            <input
              type="text"
              class="form-control"
              v-validate="'required'"
              v-model="value.lastName"
              required
              :disabled="!isEditing || noNameChange"
              placeholder="Last name" />
          </div>

          <hr v-if="showName">

          <div class="form-group col col-md-12">
            <input
              name="Address"
              type="text"
              class="form-control fs-hide"
              :class="{'is-invalid' : errors.has('Address')}"
              v-validate="'required'"
              v-model="value.addressLine1"
              required
              :disabled="!isEditing"
              placeholder="Address" />
              <div class="invalid-feedback" v-show="errors.has('Address')">{{ errors.first('Address') }}</div>
          </div>

          <hr>

          <div class="form-group col col-md-12">
            <input
              type="text"
              class="form-control fs-hide"
              v-model="value.addressLine2"
              :disabled="!isEditing"
              placeholder="Address" />
          </div>

          <hr>

          <div class="form-group col col-md-4">
            <input
              name="Suburb"
              type="text"
              class="form-control fs-hide"
              :class="{'is-invalid' : errors.has('Suburb')}"
              v-validate="'required'"
              v-model="value.suburb"
              required
              :disabled="!isEditing"
              placeholder="Suburb" />
              <div class="invalid-feedback" v-show="errors.has('Suburb')">{{ errors.first('Suburb') }}</div>
          </div>

          <div class="form-group-select col col-md-4">
            <vSelect
              name="State"
              placeholder="State"
              :class="{'is-invalid' : errors.has('State')}"
              :options="['ACT', 'NSW', 'NT', 'SA', 'TAS', 'QLD', 'VIC', 'WA']"
              v-model="value.state"
              label="label"
              :disabled="!isEditing"
              v-validate="'required'">
            </vSelect>
            <div class="invalid-feedback" v-show="errors.has('State')">{{ errors.first('State') }}</div>
          </div>


          <div class="form-group col col-md-4" :class="{ 'has-danger' : errors.has('postcode') }">
            <input
                type="text"
                name="Postcode"
                class="form-control"
                v-validate="'required'"
                :class="{ 'is-invalid' : errors.has('Postcode') }"
                v-model="value.postcode"
                required
                :disabled="!isEditing"
                placeholder="Postcode"
                 />
            <div class="invalid-feedback" v-show="errors.has('Postcode')">{{ errors.first('Postcode') }}</div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import UserMixins from '@/mixins/userProfile'
import vSelect from 'vue-select'

export default {
  name: 'ModalAddress',
  props: {
    value: Object,
    noNameChange: Boolean,
    hideNameChange: Boolean
  },
  mixins: [ UserMixins ],
  data: function () {
    return {
      isEditing: false,
      inputVal: this.value
    }
  },
  components: {
    vSelect
  },
  computed: {
    showName () {
      return !this.hideNameChange
    }
  },
  methods: {
    toggleEditing: function () {
      if (this.isValidAddress(this.value) === false && this.isEditing === true) return
      this.isEditing = !this.isEditing
    }
  }
}
</script>

 <style scoped lang="scss">
  .form{
    margin-top: 0.5rem;
  }



 </style>



// WEBPACK FOOTER //
// src/components/models/components/ModalAddress.vue